// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

const PERMISSION_BASE_URL = '/api/v1/roles/permissions';
const MODULE_BASE_URL = '/api/v1/roles/modules';

/**
 * 获取权限列表
 * @param params 查询参数
 * @param options 请求配置
 */
export async function getPermissionList(
  params?: OA.PermissionListParams,
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<OA.PermissionListData>>(PERMISSION_BASE_URL, {
    method: 'GET',
    params: params || {},
    ...(options || {}),
  });
}

/**
 * 创建权限
 * @param data 权限数据
 * @param options 请求配置
 */
export async function createPermission(
  data: OA.CreatePermissionParams,
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<{ id: number }>>(PERMISSION_BASE_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 获取权限详情
 * @param permissionId 权限ID
 * @param options 请求配置
 */
export async function getPermissionDetail(
  permissionId: number,
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<OA.Permission>>(`${PERMISSION_BASE_URL}/${permissionId}`, {
    method: 'GET',
    ...(options || {}),
  });
}

/**
 * 更新权限信息
 * @param permissionId 权限ID
 * @param data 更新数据
 * @param options 请求配置
 */
export async function updatePermission(
  permissionId: number,
  data: OA.UpdatePermissionParams,
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<null>>(`${PERMISSION_BASE_URL}/${permissionId}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 删除权限
 * @param permissionId 权限ID
 * @param options 请求配置
 */
export async function deletePermission(
  permissionId: number,
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<null>>(`${PERMISSION_BASE_URL}/${permissionId}`, {
    method: 'DELETE',
    ...(options || {}),
  });
}

/**
 * 获取权限模块列表
 * @param options 请求配置
 */
export async function getPermissionModules(
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<string[]>>(MODULE_BASE_URL, {
    method: 'GET',
    ...(options || {}),
  });
}

